module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "promotion-campaign-filters promotion-table-filters ad-d-flex ad-d-flex-between"
  }, [_c('div', {
    staticClass: "promotion-table-filters-left-part ad-d-flex ad-d-flex-start"
  }, [_c('div', {
    staticClass: "ad-d-flex"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.CreateCampaign
    }
  }, [_vm._v("新建广告组")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-edit",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchCampaign
    }
  }, [_vm._v("批量修改")])], 1)])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "广告组名称",
      "align": "left",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-link', {
          staticStyle: {
            "font-size": "12px"
          },
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.lookAds(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "广告组状态",
      "align": "center",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 'CAMPAIGN_STATUS_ENABLE') ? _c('span', [_c('i', {
          staticClass: "fa fa-circle",
          staticStyle: {
            "color": "#4dd599",
            "font-size": "7px",
            "margin-right": "2px"
          }
        }), _vm._v(" " + _vm._s(scope.row.statusName))]) : _c('span', [_c('i', {
          staticClass: "fa fa-circle",
          staticStyle: {
            "color": "#999",
            "font-size": "7px",
            "margin-right": "2px"
          }
        }), _vm._v(" " + _vm._s(scope.row.statusName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "watch_num",
      "label": "组预算",
      "align": "center",
      "min-width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.budget_mode == 'BUDGET_MODE_DAY') ? _c('span', [_vm._v(_vm._s(scope.row.budget))]) : (scope.row.budget_mode == 'BUDGET_MODE_INFINITE') ? _c('span', [_vm._v("不限")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cost",
      "label": "消耗(元)",
      "width": "100",
      "sortable": "",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.show",
      "sortable": "",
      "label": "展示",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.click",
      "sortable": "",
      "label": "点击",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.convert",
      "sortable": "",
      "label": "转化数",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cpi",
      "sortable": "",
      "label": "CPI",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cpm",
      "sortable": "",
      "label": "CPM",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.ctr",
      "sortable": "",
      "label": "CTR(%)",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "report.cvr",
      "sortable": "",
      "label": "CVR(%)",
      "width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "color": "#2F88FF"
          },
          attrs: {
            "type": "text",
            "plain": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "color": "#6f9a8d"
          },
          attrs: {
            "type": "text",
            "plain": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.copyCampaign(scope.row)
            }
          }
        }, [_vm._v("复制")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-check",
      "disabled": this.sels.length === 0,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.updateStatus('enable')
      }
    }
  }, [_vm._v("开启")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "icon": "el-icon-video-pause",
      "disabled": this.sels.length === 0,
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.updateStatus('disable')
      }
    }
  }, [_vm._v("暂停")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "el-icon-delete",
      "size": "small",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": function($event) {
        return _vm.updateStatus('delete')
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,sizes,prev, pager, next",
      "page-size": _vm.pagesize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "广告组编辑",
      "width": "35%",
      "visible": _vm.dialogCampaignVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCampaignVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.CampaignForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "广告组名称"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.CampaignForm.campaign_name),
      callback: function($$v) {
        _vm.$set(_vm.CampaignForm, "campaign_name", $$v)
      },
      expression: "CampaignForm.campaign_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预算类型"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.CampaignForm.budget_mode),
      callback: function($$v) {
        _vm.$set(_vm.CampaignForm, "budget_mode", $$v)
      },
      expression: "CampaignForm.budget_mode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "BUDGET_MODE_INFINITE"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "BUDGET_MODE_DAY"
    }
  }, [_vm._v("日预算")])], 1)], 1), _vm._v(" "), (_vm.CampaignForm.budget_mode == 'BUDGET_MODE_DAY') ? _c('el-form-item', {
    attrs: {
      "label": "日预算"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "日预算不少于1000元",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.CampaignForm.budget),
      callback: function($$v) {
        _vm.$set(_vm.CampaignForm, "budget", $$v)
      },
      expression: "CampaignForm.budget"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogCampaignVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.editLoading),
      expression: "editLoading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.EditCampagin
    }
  }, [_vm._v("保 存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "广告组批量修改",
      "width": "35%",
      "visible": _vm.dialogCampaignBatchVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCampaignBatchVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.CampaignBatchForm,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "预算类型"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.CampaignBatchForm.budget_mode),
      callback: function($$v) {
        _vm.$set(_vm.CampaignBatchForm, "budget_mode", $$v)
      },
      expression: "CampaignBatchForm.budget_mode"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "BUDGET_MODE_INFINITE"
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "BUDGET_MODE_DAY"
    }
  }, [_vm._v("日预算")])], 1)], 1), _vm._v(" "), (_vm.CampaignBatchForm.budget_mode == 'BUDGET_MODE_DAY') ? _c('el-form-item', {
    attrs: {
      "label": "日预算"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "日预算不少于1000元",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.CampaignBatchForm.budget),
      callback: function($$v) {
        _vm.$set(_vm.CampaignBatchForm, "budget", $$v)
      },
      expression: "CampaignBatchForm.budget"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogCampaignBatchVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.editLoading),
      expression: "editLoading"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.BatchEditCampagin
    }
  }, [_vm._v("确 认")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-085b7b52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/adv/model/campaign.vue
// module id = 1093
// module chunks = 38